import { gql } from '@apollo/client';

const PHYSICIAN_BY_NPI_QUERY = gql`
  query physicianByNpi($npi: String!) {
    physicianByNpi(npi: $npi)
  }
`;

export default PHYSICIAN_BY_NPI_QUERY;
